import React from 'react';
import PropTypes from 'prop-types';
import { formatDateShortMonthWithoutYear } from '@ami/react/core';

const StockRunLeadTimeLabel = ({ minimumNumberOfDays, availableOn }) => (
  <span className="inventory-item-lead-time">
    {minimumNumberOfDays}{' '}
    {minimumNumberOfDays > 1 ? 'business days' : 'business day'} after{' '}
    {formatDateShortMonthWithoutYear(availableOn)}
  </span>
);

StockRunLeadTimeLabel.propTypes = {
  minimumNumberOfDays: PropTypes.number.isRequired,
  availableOn: PropTypes.string.isRequired,
};

export default StockRunLeadTimeLabel;
